import { getDetailedErrorMessage } from "../../../utils/validation";
export class AgencyPricingFetchFailed extends Error {
    /**
     * @param apiError - The error received from the API.
     * @param fallbackMessage - The message to use if the API error is not relevant.
     */
    constructor(apiError, fallbackMessage = "Please try again at a later time.") {
        super();
        this.apiError = apiError;
        this.fallbackMessage = fallbackMessage;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AgencyPricingFetchFailed);
        }
        this.name = "AgencyPricingFetchFailed";
        this.message = `Failed to fetch agency pricing. ${getDetailedErrorMessage(apiError, fallbackMessage)}`;
    }
}
export class AgencyPricingSaveFailed extends Error {
    /**
     * @param apiError - The error received from the API.
     * @param fallbackMessage - The message to use if the API error is not relevant.
     */
    constructor(apiError, fallbackMessage = "Please try again at a later time.") {
        super();
        this.apiError = apiError;
        this.fallbackMessage = fallbackMessage;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AgencyPricingSaveFailed);
        }
        this.name = "AgencyPricingSaveFailed";
        this.message = `Failed to save agency pricing. ${getDetailedErrorMessage(apiError, fallbackMessage)}`;
    }
}
//# sourceMappingURL=errors.js.map